import React from "react";
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import HeaderComp from "../components/Header.component";
import OrgObjectivesComp from "../components/OrgObjectivesComp";
import ResultSpreadComp from "../components/ResultSpread.component"
import HelpTextComp from "../../components/helper/helptext.component";
import GoalServices from "../../services/goal.services";
import OrgResultsServices from "../services/orgResults.services";
import {orgResults, OrgResultsContainerProps, OrgResultsContainerState} from "../types/orgResults.types"
import * as OrgResultsActions from '../actions/orgResults.actions';
import ResultComparisonComp from "../components/ResultComparison/ResultComparison.component";
import OrgResultsDialog from "../components/Dialogs/OrgResults.dialog";
import KudosPingDialog from "../components/Dialogs/KudosPing.dialog";
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

const orgResultsServices = new OrgResultsServices();
class OrgResultsComp extends React.Component<orgResults, OrgResultsContainerState> {
  private plotKeyColorMapping: Object;
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalData: {},
      widthC: "520px"
    }
    // this.filterOptions = props.data.filterOptions;
    this.plotKeyColorMapping = { 
      // Key name should be lowercase
      "aggregate": "#2c9ab7",
      "okr": "#003249",
      "top20": "#339933",
      "bottom20": "#2c9ab7",
      "allTeams": "#f6babb"
    }
    window.OrgResultsComp = this;
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.modalOpen && prevProps.data.popupData !== this.props.data.popupData){
      this.renderPopup();
    }
  }

  componentDidMount(){
    setTimeout(() => {
      if(document.querySelector('#leftmenu_navigation .leftmenu-wrapper').getAttribute("data-keepopen") != "true"){
        this.onsidebarClick(false);
      }
    }, 500);
  }

  onsidebarClick(isOpen){
    var ele = window.innerWidth;
    var eleWidth = ((ele-0.2*ele));
    let chartWidth = (eleWidth - eleWidth*0.5);
    if(isOpen == "true"){
      chartWidth = chartWidth-25;
      this.setState({
        widthC: chartWidth+"px"
      })
     
    }else {
      chartWidth = chartWidth + 90; //Need to uncomment after we fix rerender component on open or close sidebar
      this.setState({
        widthC: chartWidth+"px"
      })
    }    
  }
  renderPopup = () => {
    ReactDOM.render(
      <OrgResultsDialog
        popupData= {this.props.data.popupData}
        modalData= {this.state.modalData}
        closePopup = {this.closeModal}
        // pingAll = {this.props.actions.pingAll}
        forData = {this.props.data.forData}
        handlePopupScroll = {this.handleElementScroll}
      />,
      document.getElementById("app-portal-container")
    );
  }

  showHelpText = (e) => {
    e.preventDefault();
    $(e.target).children('.helptext_popup').toggle();
  }

  handleFilterChange = (e, item) => {
    let params = {
        //teamName: val.teamName ? val.teamName : this.props.data.teamName,
        timestamp :item.value,
        forData: item.forData ? item.forData : this.props.data.forData
    }
    if(this.props.actions.updateSelection){
      if(!item.forData){
        if(item.value !== this.props.data.selectedValue){
          this.props.actions.updateSelection(params);
        }
      }else{
        this.props.actions.updateSelection(params);
      }
    }
  }

  openModal = (e, data, offset = null) => {
    const { t } = this.props;
    if(data.type === "bottom"){
      data.btn = {
        label: t("Nudge team leads"),
        iconClass: "orgIcon icon icon-outline-notifications-18px-blue"
       // onClick: this.props.actions.pingAll
      }
    }else if(data.type === "top"){
      data.btn = {
        label: t("Kudos to all"),
        iconClass: "orgIcon orgBadgeIcon",
        //onClick: null
      }
    }else if (data.type === "zero"){
      data.btn = {
        label: t("Nudge team leads"),
        iconClass: "orgIcon icon icon-outline-notifications-18px-blue"
        //onClick: this.props.actions.pingAll
      }
    }else if (data.type === "hundred"){
      data.btn = {
        label: t("Message team leads"),
        iconClass: ""
        //onClick: this.props.actions.pingAll
      }
    }
    data.btn.onClick = () => this.openAwardPingDialog(data.type);
    this.setState({
      modalOpen: true,
      modalData: data ? data : {}
    }, () => {
      let options: any = {
        type: data.type,
        offset: offset !== null ? offset : 0,
      }
      showLoaderWidget(document.querySelector("#content"));
      this.fetchPopupData(options);
    })
  }

  openAwardPingDialog = (type) => {
    let modalData;
    const { t } = this.props;
    let memCount = this.props.data.popupData.membersCount;
    if(type === "top"){
      modalData = {
        type,
        title: t("Send Kudos to All"),
        typeFullName: `${t('teams in the top')} 20%`,
        info: `${t('This message will be sent to all')} ${memCount} ${t('member')}${memCount > 1 ? "s" :""} ${t('of teams in the top')} 20% ${t('of results')}. ${t("Each team's results will be displayed below your message")}.`,
        subject: "Way to go!",
        message: `${t('I saw your great progress on results and wanted to give you a shout out! Your focus and efforts are driving real results')} -- ${t('I love it')}.`,
        members: this.props.data.popupData.membersCount
      }
    }else if (type === "bottom"){
      modalData = {
        type,
        title: t("Nudge All Team Leads"),
        typeFullName: `${t('teams in the bottom')} 20%`,
        info: `${t('This message will be sent to')} ${memCount} ${t('team lead')}${memCount > 1 ? "s" :""} ${t('whose teams are in the bottom')} 20% ${t('of results')}. ${t("Each team's results will be displayed below your message")}.`,
        subject: "Roadblocks?",
        message: `${t('I was looking at WorkBoard and noticed that your team is a bit behind on its results this quarter.')} ${t('Let me know if I can help you achieve the outcomes the team intended.')} ${t('If this data is stale, take a minute to be more transparent')} -- ${t('it helps us all make better decisions')}!`,
        members: this.props.data.popupData.membersCount
      }
    }else if (type === "zero"){
      modalData = {
        type,
        title: t("Nudge All Team Leads"),
        typeFullName: `${t("teams with")} 0% ${t("progress")}`,
        info: `${t('This message will be sent to')} ${memCount} ${t('team lead')}${memCount > 1 ? "s" :""} ${t('who have 0 progress on their OKRs in WorkBoard.')}`,
        subject: "Signal or Noise?",
        message: `${t("If your team no longer intends to focus on these objectives and results this quarter, please close them.")} ${t("If they're still active, I appreciate your focus and transparency on the progress.")} ${t("Both transparency and focus have become much more important to us all!")}`,
        members: this.props.data.popupData.membersCount
      }
    }else if (type === "hundred"){
      modalData = {
        type,
        title: t("Message All Team Leads"),
        typeFullName: `${t('teams with')} 100% ${t('progress')}`,
        info: `${t('This message will be sent to')} ${memCount} ${t('team lead')}${memCount > 1 ? "s" :""} ${t('whose teams have already hit  100% in their OKRs in WorkBoard.')}`,
        subject: "Aiming for great?",
        message: `${t("I noticed you've already hit 100% of your OKRs this quarter.")} ${t("If you think your team's best possible results are still in front of you, don't be afraid to aim for great with higher key result target (and then lean into the red to help the team focus on roadblocks to their best outcomes).")} ${t("Tap into your team's big ambitions!")}`,
        members: this.props.data.popupData.membersCount
      }
    }

    ReactDOM.render(
      <KudosPingDialog
        modalData= {modalData}
        closePopup = {this.closeKudosPingModal}
        nudgeAll = {this.props.actions.nudgeAll}
        forData = {this.props.data.forData}
        timeFrame = {this.props.data.selectedValue}
      />,
      document.getElementById("org-popup-container")
    );
  }

  fetchPopupData = (options) => {
    let params: any = {
      type: options.type,
      forData: this.props.data.forData,
      offset: options.offset !== null ? options.offset : this.props.data.popupData.data.length,
      timeFrame: this.props.data.selectedValue
    }
    this.props.actions.getPopupData(params);
  }

  handleElementScroll = (type, El) => {
    if (El && El.scrollHeight - El.scrollTop - El.clientHeight < 1) { // check you're at the bottom of the page
      let options: any = {
        type: type,
        offset: this.props.data.popupData.data.length,
      }			
      this.fetchPopupData(options);
    }
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
      modalData: {} 
    }, () => {
      //this.props.actions.clearPopupData();
      ReactDOM.unmountComponentAtNode(document.getElementById("app-portal-container"));
    })
  }

  closeKudosPingModal = (modalData) => {
    ReactDOM.unmountComponentAtNode(document.getElementById("org-popup-container"));
    if(modalData){
      let ref ;
      if (modalData.type === "top") {
        ref = 'RESULTS_ANALYTICS_KUDOS_CANCEL';
      } if (modalData.type === "hundred") {
        ref = 'RESULTS_ANALYTICS_MESSAGE_CANCEL';
      } if (modalData.type === "bottom" || modalData.type === "zero") {
        ref = 'RESULTS_ANALYTICS_NUDGE_CANCEL';
      } 
      if(ref){
       const data: any = this.props.data.forData;
       const { teamId } = data;
        orgResultsServices.resultAnalyticsEvents({
          ref : ref,
          teamId,
          timeFrame: this.props.data.selectedValue
        })
      }
    }
  }

  renderToolTipData = (key, title,count) => {
    const { t } = this.props;
    let tooltip;
    switch(key.toLowerCase()){
      case 'okr': 
        tooltip = `${t('OKR progress')}`;
        break;
      case 'aggregate':
        tooltip = `${t("Average of all teams' progress aligned to this objective")}(${count} ${t('OKRs')})`;
        break;
      case 'default':
        tooltip = undefined;
    }
    return tooltip;
  }

  render() {
    const { data } = this.props;
    return (
      <div className="goal-org-results-view">
        <HeaderComp
        displayingPeriod= {data.selectedValue}
        filterOptions = {data.filterOptions}
        fetchUserList={this.props.actions.fetchUserList}
        daysleft={data.daysleft}
        usersList={data.usersList}
        handleFilterChange={this.handleFilterChange}
        forData={data.forData}
        />
        <div className="org-results-main-container">
          {/* <div className="org-results-title">
            {
              `QTD OKR Progress`
            }
            <div className="time-left-title-text">
            {daysleft} days left in quarter
            </div>
              <HelpTextComp>
                This report shows average OKR progress percentages for a point in time.
              </HelpTextComp>
          </div> */}
          {
            data.goalData && data.goalData.length > 0 &&
            <OrgObjectivesComp
              goalData = {data.goalData}
              objKey = {data.objKey}
              dateAsOf = {data.dateAsOf}
              plotKeyColorMapping={this.plotKeyColorMapping}
              renderToolTipData={this.renderToolTipData}
              forData={data.forData}
              cQuaterName={data.cQuaterName}
            />
          }
          
          <ResultSpreadComp
          teamProgress={data.teamProgress}
          plotKeyColorMapping={this.plotKeyColorMapping}
          openModal = {this.openModal}
          directReporteeLists={data.directReporteeLists}
          forData={data.forData}
          cQuaterName={data.cQuaterName}
          />
          {
          data.QTDResults && data.QTDResults!==null && <ResultComparisonComp
          teamProgress= {data.teamProgress}
          plotKeyColorMapping= {this.plotKeyColorMapping}
          objKey= {data.objKey}
          selectedValue = {data.selectedValue}
          directReporteeLists={data.directReporteeLists}
          QTDResults = {data.QTDResults}
          forData={data.forData}
          pQuaterName={data.pQuaterName}
          widthC={this.state.widthC}
          cQuaterName={data.cQuaterName}
          />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: OrgResultsContainerProps) => ({
  data: state
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: bindActionCreators(OrgResultsActions, dispatch),
  dispatch
});

const enhance = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps));
export default enhance(OrgResultsComp);
//export default connect(mapStateToProps, mapDispatchToProps)(OrgResultsComp);
